export const castleryShop = 'castlery_shop';
